import React, { useState, useEffect } from "react";
import { FaPencilAlt, FaTrash } from "react-icons/fa";
import { FiSearch } from "react-icons/fi";
import DatePicker from "react-datepicker";
import { parseISO, format } from "date-fns";
import "react-datepicker/dist/react-datepicker.css";
import { toast, ToastContainer } from "react-toastify";
import { formatToDate } from "utils/formatTime";
import axios from "axios";
import { useMediaQuery } from "@mui/material";
import { FaPlus, FaMinus, FaCheck } from "react-icons/fa";
import { MdOutlineClose } from "react-icons/md";
import { getToken } from "utils/getToken";
import {
  btnBase,
  emptyState,
  fieldLabel,
  focusRing,
  ghostBtn,
  inlineLink,
  input as inputCls,
  microLabel,
  pageKicker,
  pageTitle,
  primaryBtn,
  select as selectCls,
  table as tableCls,
  tablePanel,
  td,
  th,
  trHover,
} from "components/ui/instrument";
import { Listbox } from "@headlessui/react";
import { HiOutlineSelector } from "react-icons/hi";
import SyncLoader from "components/Loaders/SyncLoader";
import CreateSubscriptionModal from "components/CreateSubscription/CreateSubscriptionForm";
import { HiExternalLink } from "react-icons/hi";
import UserDataPopup from "components/UserData/UserDataPopup";
import { MdCancel } from "react-icons/md";
import MultiSelect from "components/QNAs/MultiSelect";

const filterOptions = [
  { value: "HOLISTIC_OLD", name: "HOLISTIC_OLD" },
  { value: "HOLISTIC_NEW", name: "HOLISTIC_NEW" },
  { value: "NURTURE", name: "NURTURE" },
  { value: "BASIC", name: "BASIC" },
  { value: "PRIME", name: "PRIME" },
  { value: "ESSENTIAL", name: "ESSENTIAL" },
  { value: "BTP", name: "BTP" },
  { value: "WTP", name: "WTP" },
  { value: "STP", name: "STP" },
  { value: "TTP", name: "Toilet Training Program" },
  { value: "COMPLEMENTARY_CHAT", name: "COMPLEMENTARY CHAT" },
  { value: "BASIC_CHAT", name: "BASIC CHAT" },
  { value: "FREE_PREVIEW", name: "FREE PREVIEW" },
  { value: "PRIME_LIMITED_TRIAL", name: "PRIME LIMITED TRIAL" },
  { value: "BASIC_499", name: "BASIC 499" },
  { value: "YOGA BASIC", name: "YOGA_BASIC" },
  { value: "OLD_BASIC", name: "OLD BASIC" },
  { value: "OLD_PRIME", name: "OLD PRIME" },
  { value: "OLD_PRIMIUM", name: "OLD PRIMIUM" },
  { value: "ONEWEEK_TRIAL", name: "ONEWEEKTRIAL" },
];

const sortingOptions = [
  { value: "asc", name: "Ascending" },
  { value: "desc", name: "Descending" },
];

const Subscription = () => {
  const [token, setToken] = useState(getToken());
  const [data, setData] = useState<any[]>([]);
  const [filterText, setFilterText] = useState("");
  const [selectedUser, setSelectedUser] = useState<any>(null);
  const [showModal, setShowModal] = useState(false);
  const [startDate, setStartDate] = useState<any>(new Date());
  const [endDate, setEndDate] = useState<any>(new Date());
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [filterPage, setFilterPage] = useState("");
  const [comment, setComment] = useState<any>("");
  const [commentError, setCommentError] = useState(false);
  const [paymentAmount, setPaymentAmount] = useState<any>(0);
  const [editableMaxCalls, setEditableMaxCalls] = useState<any>("");
  const [isCreateSubscriptionModalOpen, setIsCreateSubscriptionModalOpen] =
    useState(false);
  const [isSearchButtonClicked, setIsSearchButtonClicked] = useState(false);
  const [reasonData, setReasonData] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [modalLoading, setModalLoading] = useState(false);
  const [nameFilterArray, setNameFiltersArray] = useState<string[]>([]);
  const [selectedFilterDate, setSelectedFilterDate] = useState<any>(null);
  const [isFilterChanged, setIsFilterChanged] = useState(false);
  const [sortingMethod, setSortingMethod] = useState<any>(sortingOptions[1]);
  const [fetchingSubscriptionData, setFetchingSubscriptionData] =
    useState(false);
  const [isPDataModalOpen, setIsPDataModalOpen] = useState(false);
  const [isFilterSelectedForConsultation, setIsFilterSelectedForConsultation] =
    useState(false);
  const [consultationTypeFilter, setConsultationTypeFilter] = useState("");
  const [doctorsData, setDoctorsData] = useState<any[]>([]);
  const [selectedDoctor, setSelectedDoctor] = useState<any>("");
  const [consultType, setConsultType] = useState("");
  const [assignedDoctors, setAssignedDoctors] = useState<any>({});
  const [docsObj, setDocsObj] = useState<any[]>([]); // gotten from assignedDoctors for display in UI
  const [initModalLoad, setInitModalLoad] = useState(false);

  const handlePDataModalClose = () => {
    setIsPDataModalOpen(false);
    setSelectedUser(null);
  };

  const handlePDataModal = (row: any) => {
    setSelectedUser(row.phone_number);
    // console.log(row.Chat_started_by);
    setIsPDataModalOpen(true);
  };

  const fetchData = async () => {
    try {
      let url = process.env.REACT_APP_API_URL + "subscription/subscriptions/";
      if (filterText) {
        url += `?mobile=${encodeURIComponent(filterText)}`;
      }

      const formattedPlanNameFilters = nameFilterArray.join(",") === "all" ? null : nameFilterArray.join(",");

      if (isFilterChanged) {
        setCurrentPage(1);
      }
      if (isFilterChanged) {
        setIsFilterChanged(false);
      }

      setFetchingSubscriptionData(true);

      const response = await axios.get(url, {
        headers: {
          Authorization: `Token ${token}`,
        },
        params: {
          names: formattedPlanNameFilters || null,
          start_time: selectedFilterDate ? selectedFilterDate : null,
          sorting: sortingMethod ? sortingMethod.value : null,
          page: isFilterChanged ? 1 : currentPage,
          consultation_type:
            consultationTypeFilter !== "" ? consultationTypeFilter : null,
        },
      });

      const jsonData = response.data;
      setData(jsonData.results);

      const totalItems = jsonData.count; // Total number of items from the API response
      const itemsPerPage = 50; // Number of items displayed per page

      const totalPages = Math.ceil(totalItems / itemsPerPage);
      setTotalPages(totalPages); // Set the total number of pages
    } catch (error) {
    } finally {
      setFetchingSubscriptionData(false);
    }
  };
  useEffect(() => {
    if (!isSearchButtonClicked) {
      fetchData();
    }
  }, [
    currentPage,
    isSearchButtonClicked,
    selectedFilterDate,
    sortingMethod,
    consultationTypeFilter,
    nameFilterArray
  ]);

  const handleSearchButtonClick = async () => {
    setLoading(true); // Set loading to true before starting the search

    try {
      await fetchData(); // Call the API with the updated filterText
      setIsSearchButtonClicked(true); // Set the flag to true indicating search button is clicked
    } catch (error) {
      // Handle the error if needed
    }

    setLoading(false); // Set loading to false after the search button click is complete
  };

  const handleStartDateChange = (date: any) => {
    setStartDate(date);
  };

  const handleEndDateChange = (date: any) => {
    setEndDate(date);
  };
  const handlePageSearch = () => {
    const pageNumber = parseInt(filterPage);
    if (!isNaN(pageNumber) && pageNumber >= 1 && pageNumber <= totalPages) {
      setFilterText(""); // Clear the filterText after navigation
      setIsSearchButtonClicked(false); // Reset the search button click state

      setCurrentPage(pageNumber);
    }
  };

  const handleEditClick = async (rowIndex: number) => {
    setModalLoading(true);
    const user = data[rowIndex];
    setSelectedUser(user);

    try {
      // Make the API call to g\et the data for the selected user
      const response = await axios.get(
        process.env.REACT_APP_API_URL +
          `subscription/subscriptions/?subs_id=${user.id}`,
        {
          headers: {
            Authorization: `Token ${token}`,
          },
        }
      );

      const userData = response.data.results[0]; // Assuming the API returns an array of results
      setStartDate(parseISO(userData.s_start_time));
      setEndDate(parseISO(userData.s_end_time));
      setComment(userData.comment);
      setEditableMaxCalls(userData.max_calls);
      setShowModal(true);
      setInitModalLoad(true);
      setPaymentAmount(userData.payment_amount);
      setAssignedDoctors(userData.assigned_doctor);

      // Fetch reason data for the selected user
      const reasonResponse = await axios.get(
        process.env.REACT_APP_API_URL +
          `subscription/subshistory/?suhs_id=${user.id}`,
        {
          headers: {
            Authorization: `Token ${token}`,
          },
        }
      );

      const reasonData = reasonResponse.data;
      setReasonData(reasonData);
      if (response.status === 200 && reasonResponse.status === 200) {
        setModalLoading(false);
      }
    } catch (error) {
      setModalLoading(false);
      console.error("Error fetching user data:", error);
      // Handle the error if needed
    } finally {
      setModalLoading(false);
    }
  };

  // useEffect(() => {
  //   if (docsObj.length > 0) {
  //     if (initModalLoad) {
  //       setConsultType(docsObj[0]?.type);
  //     }
  //     setSelectedDoctor(docsObj[0]?.id);
  //   } else {
  //     setSelectedDoctor(doctorsData[0]?.id);
  //   }
  // }, [docsObj, doctorsData, initModalLoad]);

  const handleCloseModal = () => {
    setInitModalLoad(false);
    setShowModal(false);
  };

  const handleFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setFilterText(value);
    setIsSearchButtonClicked(false); // Reset the search button click state when filter text changes
  };

  const handleNameFilterChange = (newSelectedStatuses: string[]) => {
    setNameFiltersArray(newSelectedStatuses);
  };

  useEffect(() => {
    if (!showModal) {
      setCommentError(false);
    }
  }, [showModal]);

  const handleSaveClick = async () => {
    const updatedUser = {
      ...selectedUser,
      s_start_time: format(startDate, "yyyy-MM-dd'T'HH:mm:ss.SSSxxx"),
      s_end_time: format(endDate, "yyyy-MM-dd'T'HH:mm:ss.SSSxxx"),
      comment: comment,
      max_calls: parseInt(editableMaxCalls),
    };
    if (comment === undefined || comment?.trim().length === 0) {
      setCommentError(true);
    } else {
      try {
        const updateData = JSON.stringify({
          subscription_id: updatedUser.id,
          s_end_time: updatedUser.s_end_time,
          s_start_time: updatedUser.s_start_time,
          max_calls: updatedUser.max_calls,
          payment_number: updatedUser.phone_number,
          reason: comment,
          payment_amount: paymentAmount,
          assigned_doctor: {
            [consultType]: parseInt(selectedDoctor),
          },
        });

        const config = {
          method: "post",
          url: process.env.REACT_APP_API_URL + "subscription/update/",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
          },
          data: updateData,
        };

        // Update the data on the server using Axios
        const response = await axios(config);

        // Update the data in the state
        setData((prevData) =>
          prevData.map((user) =>
            user.id === updatedUser.id ? updatedUser : user
          )
        );
        toast.success("Details updated successfully.");
        setShowModal(false);
      } catch (error) {
        console.error(error);
      }
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage((prevPage) => prevPage + 1);
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1);
    }
  };

  const handleCommentChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const { value } = e.target;
    setComment(value);
  };

  const handleMaxCallsChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setEditableMaxCalls(value);
  };

  const isSmallScreen = useMediaQuery("(max-width: 768px)");
  const numberOfButtons = isSmallScreen ? 4 : 10;

  // Function to toggle the modal's visibility
  const toggleModal = () => {
    setIsCreateSubscriptionModalOpen(!isCreateSubscriptionModalOpen);
  };

  const handleDateChange = (date: string) => {
    setSelectedFilterDate(date);
    setIsFilterChanged(true);
  };

  const handleRefresh = async () => {
    fetchData();
  };

  const handleFilterChangeForConsultationType = (value: string) => {
    setConsultationTypeFilter(value);
    setIsFilterSelectedForConsultation(true);
    setCurrentPage(1);
  };

  const FetchDoctorGrowthandLactation = async (category: string) => {
    if (category !== "") {
      try {
        const { data } = await axios.get(
          category === "lactation" || category === "growth"
            ? `${process.env.REACT_APP_API_URL}doctors/doctors/all/?category=${category}`
            : `${process.env.REACT_APP_API_URL}doctors/doctors/all`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Token ${getToken()}`,
            },
          }
        );
        setDoctorsData(data);
        setSelectedDoctor(data[0]?.id)
      } catch (error) {
        console.error("Error fetching doctors:", error);
        toast.error("Failed to fetch doctors");
      }
    }
  };

  useEffect(() => {
    FetchDoctorGrowthandLactation(consultType);
  }, [consultType]);

  useEffect(() => {
    if (showModal) {
      if (assignedDoctors !== null && assignedDoctors !== undefined) {
        const objKeys = Object.keys(assignedDoctors).map((key) => {
          return {
            type: key,
            doctor: assignedDoctors[key]?.name,
            id: assignedDoctors[key]?.id,
          };
        });
        if (objKeys.length !== 0) {
          setDocsObj(objKeys);
        } else {
          setDocsObj([]);
        }
      }
    } else {
      setConsultType("");
      setDoctorsData([]);
      setDocsObj([]);
    }
  }, [showModal]);
  return (
    <div className="mx-auto px-4 md:mx-0 md:w-full md:p-4">
      <div className="my-6 flex items-center justify-between">
        <div>
          <p className={pageKicker}>Babynama Clinic-OS</p>
          <h1 className={pageTitle}>Subscription</h1>
        </div>

        <div className="flex flex-col items-center justify-between md:flex-row">
          <button
            className={`${primaryBtn} mt-2 mb-4 w-full md:hidden`}
            onClick={toggleModal}
          >
            {isCreateSubscriptionModalOpen ? (
              <FaMinus className="mr-2 inline-block" />
            ) : (
              <>
                <FaPlus className="mr-2 inline-block" />
              </>
            )}
            Create Subscription
          </button>

          <div className="flex items-center gap-3">
            <button
              className={`${primaryBtn} my-2 mt-2 hidden items-center md:flex`}
              onClick={toggleModal}
            >
              {isCreateSubscriptionModalOpen ? (
                <FaMinus className="mr-2 inline-block" />
              ) : (
                <>
                  <FaPlus className="mr-2 inline-block" /> Create Subscription
                </>
              )}
            </button>

            <div className="hidden md:block">
              <button
                disabled={fetchingSubscriptionData}
                className={ghostBtn}
                onClick={() => handleRefresh()}
              >
                Refresh
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-[1fr,2fr]">
        {/* Filter input */}
        <div className="flex items-center justify-between gap-6">
          <div className="relative mt-[3px] flex w-[355px] flex-grow items-center gap-2 md:w-[365px] md:flex-grow-0">
            <div className="flex h-full w-full items-center">
              <input
                type="text"
                placeholder=" User Phone Number"
                value={filterText}
                onChange={handleFilterChange}
                className={inputCls}
              />
            </div>
            <button
              className={primaryBtn}
              onClick={handleSearchButtonClick}
              disabled={loading} // Disable the button while loading
            >
              {loading ? (
                "Loading..."
              ) : (
                <div className="flex">
                  {/* <FiSearch  /> */}
                  Search
                </div>
              )}
            </button>
          </div>

          <div className="md:hidden">
            <button
              disabled={fetchingSubscriptionData}
              className={ghostBtn}
              onClick={() => handleRefresh()}
            >
              Refresh
            </button>
          </div>
        </div>

        {/* Filters */}
        <div className="my-4 flex items-center justify-end">
          <div className="flex items-center justify-start gap-4">
            {/* filter by consultation tye */}
            <div className="flex">
              <div>
                <select
                  className={`${selectCls} ${
                    consultationTypeFilter !== "" ? "font-semibold" : ""
                  }`}
                  value={consultationTypeFilter}
                  onChange={(e) => {
                    handleFilterChangeForConsultationType(e.target.value);
                  }}
                >
                  <option value="">Check Pending Calls</option>
                  <option value="growth">Growth</option>
                </select>
              </div>
              {consultationTypeFilter !== "" && (
                <button
                  type="button"
                  aria-label="Clear consultation type filter"
                  className={`relative left-1 top-3 cursor-pointer rounded text-clinic-400 hover:text-clinic-600 ${focusRing}`}
                  onClick={(e) => {
                    e.stopPropagation();
                    setConsultationTypeFilter("");
                    setIsFilterSelectedForConsultation(false);
                  }}
                >
                  <MdCancel />
                </button>
              )}
            </div>
            {/* Filter By Name */}
            <div className="relative">
              <MultiSelect filterOptions={filterOptions} onChange={handleNameFilterChange} filterName="Name" selectAll/>
            </div>

            {/* Filter By Sorting Method */}
            <div className="relative">
              <Listbox value={sortingMethod} onChange={setSortingMethod}>
                {({ open }) => (
                  <>
                    <div className="relative inline-block text-left">
                      <Listbox.Button
                        as="div"
                        className={`inline-flex w-full cursor-pointer items-center justify-center gap-4 rounded-md border border-clinic-300 bg-white px-4 py-1.5 text-sm text-clinic-700 hover:bg-clinic-50 ${focusRing}`}
                      >
                        {sortingMethod
                          ? `${sortingMethod.name}`
                          : "Choose Sorting Method"}
                        {sortingMethod ? (
                          <button
                            onClick={() => setSortingMethod("")}
                            aria-label="Clear sorting method"
                            className={`ml-2 flex items-center rounded text-clinic-400 hover:text-clinic-600 ${focusRing}`}
                          >
                            <MdOutlineClose size={22} />
                          </button>
                        ) : (
                          <HiOutlineSelector size="22" />
                        )}
                      </Listbox.Button>
                    </div>
                    <Listbox.Options
                      className="absolute z-10 mt-1 max-h-60 min-w-[180px] overflow-auto rounded-md border border-clinic-200 bg-white py-1 text-base shadow-lg focus:outline-none sm:text-sm"
                      style={{ display: open ? "block" : "none" }}
                    >
                      {sortingOptions.map((option, index) => (
                        <Listbox.Option
                          key={index}
                          value={option}
                          className={({ active }) =>
                            `${
                              active
                                ? "bg-clinic-100 text-clinic-900"
                                : "text-clinic-700"
                            }
                        relative cursor-pointer select-none py-2 pl-1 pr-4`
                          }
                        >
                          {({ selected, active }) => (
                            <>
                              <div className="flex items-center gap-3">
                                <input
                                  type="checkbox"
                                  checked={selected ? true : false}
                                  className="cursor-pointer"
                                />
                                <span
                                  className={`${
                                    selected ? "font-semibold" : "font-normal"
                                  }`}
                                >
                                  {option.name}
                                </span>
                              </div>
                            </>
                          )}
                        </Listbox.Option>
                      ))}
                    </Listbox.Options>
                  </>
                )}
              </Listbox>
            </div>

            {/* Date Filter */}
            <div className="relative inline-flex items-center justify-center gap-4 rounded-md border border-clinic-300 bg-white text-sm text-clinic-700 hover:bg-clinic-50">
              <input
                id="dob"
                name="dob"
                type="date"
                value={selectedFilterDate}
                onChange={(e) => handleDateChange(e.target.value)}
                max={new Date().toISOString().split("T")[0]}
                placeholder="Filter By Date"
                className={`w-full rounded-md bg-white px-3 py-2 tabular-nums text-clinic-700 ${focusRing}`}
              />

              {selectedFilterDate && (
                <div className="ml-5">
                  <button
                    onClick={() => {
                      setSelectedFilterDate("");
                      setIsFilterChanged(true);
                    }}
                    aria-label="Clear date filter"
                    className={`absolute top-3 right-2 rounded text-clinic-400 hover:text-clinic-600 ${focusRing}`}
                  >
                    <MdOutlineClose size={22} />
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
        {/* Filters end */}
      </div>

      {isCreateSubscriptionModalOpen && (
        <CreateSubscriptionModal onClose={toggleModal} />
      )}

      <div className="mx-auto sm:hidden">
        {/* List items */}
        {data.length > 0 ? (
          data.map((row, rowIndex) => (
            <div
              key={rowIndex}
              className="mb-4 rounded-lg border border-clinic-200 bg-white p-4 shadow-sm"
            >
              <div className="mb-2 flex justify-between">
                <div>
                  <p className="text-lg font-semibold tabular-nums text-clinic-900">
                    {row.id}
                  </p>
                  <p className="tabular-nums text-clinic-700">
                    {row.phone_number}
                  </p>
                </div>
                <div>
                  <p className="text-lg font-semibold text-clinic-900">
                    {row.plan_name}
                  </p>
                </div>
              </div>
              <div className="flex justify-between">
                <div>
                  <p className={microLabel}>Start Date</p>
                  <p className="tabular-nums text-clinic-700">
                    {format(parseISO(row.s_start_time), "yyyy-MM-dd HH:mm:ss")}
                  </p>
                </div>
              </div>
              <div className="flex justify-between">
                <div>
                  <p className={microLabel}>End Date</p>
                  <p className="tabular-nums text-clinic-700">
                    {format(parseISO(row.s_end_time), "yyyy-MM-dd HH:mm:ss")}
                  </p>
                </div>
              </div>

              <div className="flex justify-between">
                <div>
                  <p className={microLabel}>Max Calls</p>
                  <p className="tabular-nums text-clinic-700">{row.max_calls}</p>
                </div>
                <div>
                  <p className={microLabel}>Used Calls</p>
                  <p className="tabular-nums text-clinic-700">{row.used_calls}</p>
                </div>
              </div>
              <div className="mt-2 flex justify-end">
                <div>
                  <button
                    type="button"
                    aria-label="Edit"
                    onClick={() => handleEditClick(rowIndex)}
                    className={`mr-2 cursor-pointer rounded p-1 text-action-600 hover:text-action-700 ${focusRing}`}
                  >
                    <FaPencilAlt />
                  </button>
                </div>
              </div>
            </div>
          ))
        ) : (
          <p className={emptyState}>No data available</p>
        )}
      </div>
      {/* new way to show user data in modal */}
      {isPDataModalOpen && (
        <UserDataPopup
          selectedUser={selectedUser}
          noSearch={true}
          handlePDataModalClose={handlePDataModalClose}
        />
      )}

      {/* Desktop View Data */}
      {!fetchingSubscriptionData && data.length > 0 ? (
        <div className={`hidden min-h-[60vh] max-w-full md:block ${tablePanel}`}>
          <table className={tableCls}>
            <thead>
              <tr>
                <th className={th}>ID</th>
                <th className={th}>User</th>
                <th className={th}>Plan Name</th>
                <th className={th}>Start Date</th>
                <th className={th}>End Date</th>
                <th className={th}>Max Calls</th>
                <th className={th}>Used Calls</th>
                {/* <th className={th}>Reason</th> */}
                <th className={th}>Actions</th>
                <th className={th}>Status</th>
              </tr>
            </thead>
            <tbody>
              {data.length > 0 ? (
                data.map((row, rowIndex) =>{
                  return (<tr key={rowIndex} className={`${row.is_active ? trHover : 'bg-clinic-50 transition-colors hover:bg-clinic-100 motion-reduce:transition-none'}`}>
                    <td className={`${td} tabular-nums`}>{row.id}</td>
                    <td className={td}>
                      <button
                        className={`${inlineLink} text-left`}
                        onClick={() => {
                          handlePDataModal(row);
                        }}
                      >
                        <p className="tabular-nums">{row.phone_number}</p> <HiExternalLink />
                        <p>{row?.name || ""}</p>
                      </button>
                    </td>
                    <td className={td}>{row.plan_name}</td>
                    <td className={`${td} tabular-nums`}>
                      {format(
                        parseISO(row.s_start_time),
                        "yyyy-MM-dd HH:mm:ss"
                      )}
                    </td>
                    <td className={`${td} tabular-nums`}>
                      {format(parseISO(row.s_end_time), "yyyy-MM-dd HH:mm:ss")}
                    </td>
                    <td className={`${td} tabular-nums`}>{row.max_calls}</td>
                    <td className={`${td} tabular-nums`}>{row.used_calls}</td>
                    {/* <td className={td}>{row.comment}</td> */}
                    <td className={td}>
                      <button
                        type="button"
                        aria-label="Edit"
                        onClick={() => handleEditClick(rowIndex)}
                        className={`mr-2 cursor-pointer rounded p-1 text-action-600 hover:text-action-700 ${focusRing}`}
                      >
                        <FaPencilAlt />
                      </button>
                    </td>
                    <td className={td}>
                      <span
                        className={`inline-flex rounded px-1.5 py-px text-[11px] font-semibold ${
                          row.is_active
                            ? 'bg-clinic-100 text-clinic-700 ring-1 ring-clinic-200'
                            : 'bg-warn-100 text-warn-700 ring-1 ring-warn-200'
                        }`}
                      >
                        {row.is_active ? 'Active' : 'Expired'}
                      </span>
                    </td>
                  </tr>)
              })
              ) : (
                <tr>
                  <td className={emptyState} colSpan={6}>
                    No data available
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      ) : fetchingSubscriptionData ? (
        <div className="flex h-[70vh] items-center justify-center">
          <SyncLoader color={"#0e7490"} size={10} />
        </div>
      ) : (
        <div className="flex h-full min-h-[60vh] w-full items-center justify-center">
          <p className={emptyState}>
            No Subscription Data available
          </p>
        </div>
      )}
      <div className="mt-10 flex flex-col justify-center md:mt-20 md:flex-row">
        <div className="flex justify-center md:ml-auto">
          <button
            onClick={handlePrevPage}
            disabled={currentPage === 1}
            aria-label="Previous page"
            className={`${ghostBtn} md:px-8`}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fillRule="evenodd"
                d="M9.707 4.293a1 1 0 010 1.414L6.414 9H16a1 1 0 110 2H6.414l3.293 3.293a1 1 0 01-1.414 1.414l-5-5a1 1 0 010-1.414l5-5a1 1 0 011.414 0z"
                clipRule="evenodd"
              />
            </svg>
          </button>
          {totalPages > 1 &&
            [
              ...Array(Math.min(numberOfButtons, totalPages - currentPage + 1)),
            ].map((_, index) => {
              const pageNumber = currentPage + index;
              return (
                <button
                  key={index}
                  onClick={() => setCurrentPage(pageNumber)}
                  disabled={pageNumber > totalPages}
                  className={`${btnBase} ml-2 tabular-nums ${
                    currentPage === pageNumber
                      ? "bg-clinic-900 text-white dark:bg-white dark:text-navy-700"
                      : "bg-white text-clinic-600 ring-1 ring-clinic-300 hover:bg-clinic-100 hover:text-clinic-900"
                  }`}
                >
                  {pageNumber}
                </button>
              );
            })}

          <button
            onClick={handleNextPage}
            disabled={currentPage === totalPages}
            aria-label="Next page"
            className={`${ghostBtn} mx-2 md:px-8`}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5 -rotate-180 transform"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fillRule="evenodd"
                d="M9.707 4.293a1 1 0 010 1.414L6.414 9H16a1 1 0 110 2H6.414l3.293 3.293a1 1 0 01-1.414 1.414l-5-5a1 1 0 010-1.414l5-5a1 1 0 011.414 0z"
                clipRule="evenodd"
              />
            </svg>
          </button>
        </div>
        <div className="relative mt-5 flex items-center justify-end md:ml-auto md:mt-0 ">
          <input
            type="text"
            placeholder={`Go to page (1 - ${totalPages})`}
            value={filterPage}
            onChange={(e) => setFilterPage(e.target.value)}
            className={`${inputCls} tabular-nums`}
          />
          <button
            className={`${primaryBtn} mx-2`}
            aria-label="Go to page"
            onClick={handlePageSearch}
          >
            <FiSearch
              className="h-4 w-4 cursor-pointer rounded-lg"
              onClick={handlePageSearch}
            />
          </button>
        </div>
      </div>

      {selectedUser && showModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center overflow-hidden">
          <div className="absolute inset-0 bg-clinic-900 opacity-75"></div>
          <div className="custom-scrollbar relative z-10 mx-4 h-[95vh] w-full overflow-y-auto rounded bg-white md:mx-auto md:max-w-lg">
            <div className="p-4 md:p-8">
              <h2 className="text-center text-lg font-bold tracking-tight text-clinic-900">
                Subscription Data
              </h2>
              <div className="mt-2 space-y-4 md:mt-4">
                <div className="flex flex-col">
                  <p className={fieldLabel}>ID:</p>
                  <p className="rounded-md border border-clinic-200 bg-clinic-50 px-3 py-2 text-sm tabular-nums text-clinic-800">
                    {selectedUser.id}
                  </p>
                </div>
                <div className="flex flex-col">
                  <p className={fieldLabel}>Phone Number:</p>
                  <p className="rounded-md border border-clinic-200 bg-clinic-50 px-3 py-2 text-sm tabular-nums text-clinic-800">
                    {selectedUser.phone_number}
                  </p>
                </div>
                <div className="flex flex-col">
                  <p className={fieldLabel}>Plan Name:</p>
                  <p className="rounded-md border border-clinic-200 bg-clinic-50 px-3 py-2 text-sm text-clinic-800">
                    {selectedUser.plan_name}
                  </p>
                </div>
                <div className="flex flex-col space-y-4 md:flex-row md:space-y-0 md:space-x-8">
                  <div className="flex flex-col">
                    <p className={fieldLabel}>Start Date:</p>
                    <DatePicker
                      selected={startDate}
                      onChange={handleStartDateChange}
                      className={inputCls}
                      dateFormat="dd/MM/yyyy"
                    />
                    <p className="pl-2 text-sm font-medium tabular-nums text-clinic-700">
                      {formatToDate(startDate)}
                    </p>
                  </div>
                  <div className="flex flex-col">
                    <p className={fieldLabel}>End Date:</p>
                    <DatePicker
                      selected={endDate}
                      onChange={handleEndDateChange}
                      className={inputCls}
                      dateFormat="dd/MM/yyyy"
                    />
                    <p className="pl-2 text-sm font-medium tabular-nums text-clinic-700">
                      {formatToDate(endDate)}
                    </p>
                  </div>
                </div>
                {/* Display subscription history */}
                {/* Display subscription history */}
                <div className="mt-2 md:mt-4">
                  <h3 className={microLabel}>
                    Subscription History:
                  </h3>
                  <div className="rounded-lg border border-clinic-200 bg-clinic-50 px-4 pb-2">
                    <div className="mt-2 flex justify-between">
                      <p className={microLabel}>Reason</p>
                      <p className={microLabel}>Timestamp</p>
                    </div>
                    {reasonData.map((historyItem, index) => (
                      <div key={index} className="mt-2 flex justify-between">
                        <p className="text-sm text-clinic-700">
                          {historyItem.reason}
                        </p>
                        <p className="text-sm tabular-nums text-clinic-700">
                          {format(
                            parseISO(historyItem.timestamp),
                            "yyyy-MM-dd HH:mm:ss"
                          )}
                        </p>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="flex flex-col">
                  <p className={fieldLabel}>Comment:</p>
                  <textarea
                    value={comment}
                    onChange={handleCommentChange}
                    className={inputCls}
                  />
                  {commentError && (
                    <p className="mt-1 text-sm text-crit-600">Comment is required!</p>
                  )}
                </div>
                {docsObj.length > 0 ? (
                  <div>
                    <div className="mt-2 flex justify-between">
                      <p className={microLabel}>Consultation type</p>
                      <p className={microLabel}>Assigned Doctor</p>
                    </div>
                    {docsObj.map((item, i) => (
                      <div key={i} className="mt-2 flex justify-between">
                        <p className="capitalize text-clinic-700">{item.type}</p>
                        <p className="capitalize text-clinic-700">{item.doctor}</p>
                      </div>
                    ))}
                  </div>
                ) : null}
                <div className="flex items-center gap-x-4">
                  <div className="mb-1 flex w-1/2 flex-col items-center">
                    <label className={fieldLabel}>
                      Consultation type
                    </label>
                    <select
                      value={consultType}
                      onChange={(e) => {
                        setInitModalLoad(false);
                        setConsultType(e.target.value);
                      }}
                      className={`${selectCls} mr-2 w-full`}
                    >
                      <option value="">Choose an option</option>
                      <option value="lactation">lactation</option>
                      <option value="nutrition">nutrition</option>
                      <option value="gyne">gyne</option>
                      <option value="derma">derma</option>
                      <option value="pediatric">pediatric</option>
                      <option value="growth">growth</option>
                    </select>
                  </div>
                  <div className="mb-1 flex w-1/2 flex-col items-center">
                    <label className={fieldLabel}>
                      Assigned Doctor
                    </label>
                    <select
                      value={selectedDoctor}
                      onChange={(e) => setSelectedDoctor(e.target.value)}
                      className={`${selectCls} mr-2 w-full`}
                    >
                      {doctorsData?.map((doc, i) => (
                        <option key={i} value={doc.id}>
                          {doc.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="flex flex-col">
                  <p className={fieldLabel}>Max Calls:</p>
                  <input
                    type="number"
                    value={editableMaxCalls}
                    onChange={handleMaxCallsChange}
                    className={`${inputCls} tabular-nums`}
                  />
                </div>
                <div className="flex flex-col">
                  <p className={fieldLabel}>Payment Amount:</p>
                  <input
                    type="number"
                    value={paymentAmount}
                    onChange={(e) => setPaymentAmount(e.target.value)}
                    className={`${inputCls} tabular-nums`}
                  />
                </div>
              </div>
              {/* Save and Cancel buttons */}
              <div className="mt-6 flex justify-end">
                <button
                  onClick={handleSaveClick}
                  className={`${primaryBtn} mr-2 px-8`}
                >
                  Save
                </button>
                <button
                  onClick={handleCloseModal}
                  className={`${ghostBtn} px-8`}
                >
                  Cancel
                </button>
              </div>
              {/* Close icon */}
              <button
                type="button"
                aria-label="Close"
                className={`absolute top-0 right-0 m-3 cursor-pointer rounded p-1 text-clinic-500 transition-colors hover:text-clinic-800 motion-reduce:transition-none ${focusRing}`}
                onClick={handleCloseModal}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  aria-label="Close"
                  className="icon icon-tabler icon-tabler-x"
                  width={20}
                  height={20}
                  viewBox="0 0 24 24"
                  strokeWidth="2.5"
                  stroke="currentColor"
                  fill="none"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path stroke="none" d="M0 0h24v24H0z" />
                  <line x1={18} y1={6} x2={6} y2={18} />
                  <line x1={6} y1={6} x2={18} y2={18} />
                </svg>
              </button>
            </div>
          </div>
        </div>
      )}

      <ToastContainer
        position="bottom-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss={false}
        draggable
        pauseOnHover
        theme="light"
      />
    </div>
  );
};

export default Subscription;
